import { translate } from "../../util/translate"

export const headers = [
  { text: translate['batchSchedule.label.code'], value: 'appointment.code' },
  { text: translate['batchSchedule.label.date'], value: 'appointment.date' },
  { text: translate['batchSchedule.label.type'], value: 'appointment.type' },
  { value: 'error', align: 'center', width: 150 },
  {
    text: '',
    align: 'center',
    value: 'data-table-expand',
    width: 50,
  },
]

export const appointmentsToScheduleHeaders = [
  { text: translate['batchSchedule.label.type'], value: 'tipo' },
  { text: translate['batchSchedule.label.date'], value: 'data' },
  { text: translate['batchSchedule.label.realtyCode'], value: 'codigo_do_imovel' },
]
